import { api } from "@/services/api";

const initState = () => ({
  linguistPositiveFlagOptions: [],
  linguistNegativeFlagOptions: [],
  customerPositiveFlagOptions: [],
  customerNegativeFlagOptions: [],
  customerConnectionPositiveFlagsOptions: [],
  customerConnnectionNegativeFlagsOptions: [],
  linguistConnectionPositiveFlagsOptions: [],
  linguistConnnectionNegativeFlagsOptions: [],
});
const getters = {};
const actions = {
  getRatingTags({ commit }, data) {
    return new Promise((resolve, reject) => {
      let apiurl = `v1/sessions/${data.sessionID}/rating-tags`;
      return api
        .get(apiurl)
        .then((res) => {
          let results = res.data;
          let linguistRatingNegativeTags = results.person["1"].filter((x) => {
            if (x.role === "linguist") {
              return x;
            }
          });
          let linguistRatingPositiveTags = results.person["5"].filter((x) => {
            if (x.role === "linguist") {
                return x;
            }
          });
          let customerRatingNegativeTags = results.person["1"].filter((x) => {
            if (x.role === "creator") {
                return x;
            }
          });
          let customerRatingPositiveTags = results.person["5"].filter((x) => {
            if (x.role === "creator") {
                return x;
            }
          });
          let linguistConnectionRatingNegativeTags = results.technical["1"].filter(x => {
            if(x.role === 'linguist'){
              return x;
            }
          });
          let linguistConnectionRatingPositiveTags = results.technical["5"].filter(x => {
            if(x.role === 'linguist'){
              return x;
            }
          });
            let customerConnectionRatingNegativeTags = results.technical["1"].filter(x => {
              if(x.role === 'creator'){
                return x;
              }
          });
            let customerConnectionRatingPositiveTags = results.technical["5"].filter(x => {
              if(x.role === 'creator'){
                return x;
              }
          });
          commit("updateTags", {
            data: linguistRatingPositiveTags,
            key: "linguist-positive",
          });
          commit("updateTags", {
            data: linguistRatingNegativeTags,
            key: "linguist-negative",
          });
          commit("updateTags", {
            data: customerRatingNegativeTags,
            key: "customer-negative",
          });
          commit("updateTags", {
            data: customerRatingPositiveTags,
            key: "customer-positive",
          });
          commit("updateTags", {
            data: linguistConnectionRatingPositiveTags,
            key: "linguist-connection-positive",
          });
          commit("updateTags", {
            data: linguistConnectionRatingNegativeTags,
            key: "linguist-connection-negative",
          });
          commit("updateTags", {
            data: customerConnectionRatingPositiveTags,
            key: "customer-connection-positive",
          });
          commit("updateTags", {
            data: customerConnectionRatingNegativeTags,
            key: "customer-connection-negative",
          });
          resolve(res.data);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  },
  submitRating({ commit }, data) {
    return new Promise((resolve, reject) => {
        api
            .post(`/v1/sessions/${data.sessionID}/ratings`, data.payload)
            .then(res => {
                resolve(res);
            })
            commit()
            .catch((e) => {
                reject(e);
            })
    })
  }
};
const mutations = {
  updateTags(state, payload) {
    switch (payload.key) {
      case "linguist-positive":
        state.linguistPositiveFlagOptions = [...payload.data];
        break;
      case "linguist-negative":
        state.linguistNegativeFlagOptions = [...payload.data];
        break;
      case "customer-positive":
        state.customerPositiveFlagOptions = [...payload.data];
        break;
      case "customer-negative":
        state.customerNegativeFlagOptions = [...payload.data];
        break;
      case "linguist-connection-positive":
        state.linguistConnectionPositiveFlagsOptions = [...payload.data];
        break;
      case "linguist-connection-negative":
        state.linguistConnectionNegativeFlagsOptions = [...payload.data];
        break;
      case "customer-connection-positive":
        state.customerConnectionPositiveFlagsOptions = [...payload.data];
        break;
      case "customer-connection-negative":
        state.customerConnectionNegativeFlagsOptions = [...payload.data];
        break;
      default:
        return state;
    }
  },
};
export default {
  namespaced: true,
  state: initState,
  getters,
  mutations,
  actions,
};